import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Flex,
  Heading,
  List,
  ListItem,
  Link,
  Icon,
  Stack,
  Button,
  useColorMode,
} from "@chakra-ui/react";
import { MdDarkMode, MdLightMode } from "react-icons/md";

// local imports
import MenuToggle from "./MenuToggle";
import useAuthContext from "../hooks/useAuthContext";
import { signOutUser } from "../services/auth";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Box as="header" py={4}>
      <Container maxW="container.lg">
        <Flex align="center" justify="space-between" wrap="wrap" w="100%">
          <Heading as="h1" size="md">
            SuperLists
          </Heading>

          <MenuToggle isOpen={isOpen} toggle={toggle} />

          <MenuLinks isOpen={isOpen} />
        </Flex>
      </Container>
    </Box>
  );
};

const MenuLinks = ({ isOpen }) => {
  const { user, setUser } = useAuthContext();
  const { colorMode, toggleColorMode } = useColorMode();

  const logoutHandler = async () => {
    await signOutUser();
    setUser(null);
  };

  return (
    <List
      display={{ base: isOpen ? "block" : "none", md: "block" }}
      flexBasis={{ base: "100%", md: "auto" }}
    >
      <Stack
        spacing={8}
        align="center"
        justify={{
          base: "center",
          sm: "space-between",
          md: "flex-end",
        }}
        direction={{ base: "column", md: "row" }}
      >
        {user && (
          <>
            <ListItem>Howdy, {user.displayName} </ListItem>
            <ListItem>
              <Link as={RouterLink} to="/dashboard">
                Dashboard
              </Link>
            </ListItem>

            <ListItem>
              <Button onClick={toggleColorMode}>
                {colorMode === "light" ? (
                  <Icon as={MdDarkMode} />
                ) : (
                  <Icon as={MdLightMode} />
                )}
              </Button>
            </ListItem>

            <ListItem>
              <Button onClick={logoutHandler} variant="link" colorScheme="red">
                Logout
              </Button>
            </ListItem>
          </>
        )}

        {!user && (
          <>
            <ListItem>
              <Link as={RouterLink} to="/">
                Home
              </Link>
            </ListItem>
            <ListItem>
              <Link as={RouterLink} to="/auth">
                Login / Register
              </Link>
            </ListItem>
            <ListItem>
              <Button onClick={toggleColorMode}>
                {colorMode === "light" ? (
                  <Icon as={MdDarkMode} />
                ) : (
                  <Icon as={MdLightMode} />
                )}
              </Button>
            </ListItem>
          </>
        )}
      </Stack>
    </List>
  );
};

export default Header;
